import React, { useState } from 'react';
import ReusableSidebar from '../../components/sidebar/reusable-sidebar';
import { useUser } from '../../services/contexts/user-context';
import { MainContent } from '../../components/sidebar/sidebar.styles';
import Dashboard from './dashboard';
import Loading from '../../components/loading';

const DefaultDashboard = () => {
  const { user, isLoading } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(() =>
    typeof window === 'undefined' || !window.matchMedia('(max-width: 768px)').matches
  );

  const handleToggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <ReusableSidebar
        isSidebarOpen={isSidebarOpen}
        handleToggleSidebar={handleToggleSidebar}
        selectedPage="dashboard"
        user={user}
        loading={isLoading}
      />

      <MainContent isSidebarOpen={isSidebarOpen}>
        {isLoading ? <Loading /> : <Dashboard />}
      </MainContent>
    </>
  );
};

export default DefaultDashboard;
